import React from 'react';
import TransactionStore from '../stores/transaction-store';
import Dispatcher from '../dispatcher';
import {VstLoader, VstTabs} from 'vstui';
import RefundsContainer from './refunds-container';
import PurchasesContainer from './purchases-container';

const TransactionsContainer = React.createClass({
  getInitialState() {
    return {
      transactions: TransactionStore.getAll() 
    };
  },

  componentDidMount() {
    Dispatcher.on(Dispatcher.TRANSACTION_STORE_CHANGE, this._handleChange);
  },

  componentWillUnmount() {
    Dispatcher.removeListener(Dispatcher.TRANSACTION_STORE_CHANGE, this._handleChange)
  },

  _handleChange() {
    this.setState({transactions: TransactionStore.getAll() });
  },

  render() {
    const purchases = this.state.transactions && this.state.transactions.purchases;
    const refunds = this.state.transactions && this.state.transactions.refunds;

    return (
      <div className="page transactions">
        <h1>{i18n.t('base.transactions')}</h1>
        <VstTabs activeIndex={this.props.activeIndex}>
          <VstTabs.Bar>
            <VstTabs.Tab>{i18n.t('transactions.purchases')}</VstTabs.Tab>
            <VstTabs.Tab>{i18n.t('transactions.refunded-items')}</VstTabs.Tab>
         </VstTabs.Bar>
         <VstTabs.Panels>
            <PurchasesContainer purchases={purchases} />
            <RefundsContainer refunds={refunds} />
          </VstTabs.Panels>
        </VstTabs>
      </div>
    );
  }
});

export default TransactionsContainer;



/** WEBPACK FOOTER **
 ** ./src/js/components/transactions-container.jsx
 **/